import { API } from '@/api/Api'

export default {

  async Get (data = {}) {
    const Endpoint = API.Endpoint.Dashboard.Get
    const Data = data
    return await API.RESTRequest(Endpoint, Data)
  },

  async GetAdmin (data = {}) {
    const Endpoint = API.Endpoint.Dashboard.GetAdmin
    const Data = data
    return await API.RESTRequest(Endpoint, Data)
  }
}
